/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".footer[_ngcontent-%COMP%]{height:4em;margin-top:4%}.footer-bg[_ngcontent-%COMP%]{height:100%}.img-footer[_ngcontent-%COMP%]{width:95%;margin-left:3%;margin-top:0;background-repeat:no-repeat}span[_ngcontent-%COMP%]{font-size:12px;color:#fff}.span-copy[_ngcontent-%COMP%]{margin-left:auto}"];
export { styles as styles };
